///
/// Copyright (c) 2017-present, Siklu Ltd.
/// All rights reserved.
///

import { GtthAbstractCommand } from '../../../abstract-command';
import { ActivityDTO } from '../../../../../../services/project-socket/activity-dto.model';
import { GtthProgressWindowModel } from '../../../../../project-windows/progress-window/progress-window.model';
import { GtthLockProjectCommand } from '../../project/lock-project-command';
import { GtthCanRunDesignCommand } from '../can-run-design-command';
import { GtthUnlockProjectCommand } from '../../project/unlock-project-command';
import { GtthRefreshTopologyCommand } from '../../project/refresh-topology-command';
import { GtthAutoDesignCommand } from '../auto-design-command';

export class GtthAutoSetFrequenciesCommand extends GtthAbstractCommand {
    private layerIndex: number;

    getCommandName(): string {
        return 'GtthAutoSetFrequenciesCommand';
    }

    create(layerIndex: number): this {
        this.layerIndex = layerIndex;
        return this;
    }

    protected doCommand(): void {
        if (!GtthAutoDesignCommand.isPopInTopologyExist(this.historyService)) {
            this.commandResolve(false);
            return;
        }

        this.historyService
            .doCommandBypassHistory(this.historyService.command(GtthCanRunDesignCommand))
            .then((canRunDesign: boolean) => {
                if (!canRunDesign) {
                    return Promise.reject();
                }
                const unlockCommand = this.historyService.command(GtthUnlockProjectCommand);
                return this.historyService.doCommandBypassHistory(unlockCommand, true);
            })
            .then((result) => {
                if (!result) {
                    return Promise.reject();
                }

                this.historyService.progressWindowService.show(GtthProgressWindowModel.create(this.getCommandName()));

                const activity = this.createActivityDTO(false);
                activity.logicalTopology = this.historyService.logicalTopology.toGeoJsonMainConfig(this.historyService, this.project.name);
                activity.designConfig = this.historyService.logicalTopology.getDesignConfig();
                activity.designConfig.layerIndex = this.layerIndex;
                this.sendActivity(activity);
            })
            .catch((_reason) => {
                this.historyService.progressWindowService.hide();
                this.commandResolve(false);
            });
    }

    doCommandActivity(activityDto: ActivityDTO): void {
        this.historyService.progressWindowService.show(GtthProgressWindowModel.createFromActivityDTO(activityDto));

        if (!activityDto.progress?.finished) {
            return;
        }

        const lockTimeout = this.commandResolve ? 0 : 1000;

        setTimeout(() => {
            const lockCommand = this.historyService.command(GtthLockProjectCommand).create(false);
            this.historyService.doCommandBypassHistory(lockCommand).then(() => {
                const refreshTopologyCommand = this.historyService.command(GtthRefreshTopologyCommand).create(false);
                this.historyService.doCommandBypassHistory(refreshTopologyCommand).then((_refreshResult: boolean) => {
                    this.historyService.clearHistory();
                    if (this.commandResolve) {
                        this.commandResolve(activityDto.successful);
                    }
                });
            });
        }, lockTimeout);
    }

    isDisabledInReadOnlyMode(): boolean {
        return true;
    }
}
